export default {
	active: function() {
		return this.$store.state.navigation.burgerActive;
	},
};
